import connect from './connect'
import Navbar from './Navbar'

export default connect(Navbar)
